import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import {Line} from 'react-chartjs-2';
import {HorizontalBar} from 'react-chartjs-2';

//tabs related import
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
import { Divider, Hidden } from '@material-ui/core';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import config from "../../config/config";
import axios from 'axios';

import {money_convert} from '../../util/StringUtil';

import { grid_spacing, styles } from '../CSS/Styles';
import "../CSS/customDatePickerWidth.css";
import CustomizedCard from '../CSSComponent/card'
import CustomizedLineChart from '../CSSComponent/lineChart'
import CustomizedHorizontalBar from '../CSSComponent/horizontalChart'

function getRandomInt(min, max) {
  //return Math.random()>0.2 ? 0: (Math.floor(Math.random() * (max - min + 1)) + min)*100000;
  return 0
}

const getState = () => ({
    data_tender_trending : {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
          {
            label: 'Purchase Order',
            backgroundColor: 'rgba(234,170,0,0.8)',
            borderColor: 'rgba(246,141,46,1)',
            //pointColor: 'rgba(220,220,220,1)',
            //pointStrokeColor: '#fff',
            //pointHighlightFill: '#fff',
            //pointHighlightStroke: 'rgba(220,220,220,1)',
            data: [1000000.00 + getRandomInt(-5, 10), 
            1300000.00 + getRandomInt(-5, 10), 
            985968.00 + getRandomInt(-5, 10), 
            700000.00 + getRandomInt(-5, 10), 
            3400000.00 + getRandomInt(-5, 10), 
            6200000.00 + getRandomInt(-5, 10), 
            4800000.00 + getRandomInt(-5, 10), 
            980000.00 + getRandomInt(-5, 10), 
            1300000.00 + getRandomInt(-5, 10), 
            960000.00 + getRandomInt(-5, 10), 
            500000.00 + getRandomInt(-5, 10), 
            1700000.00 + getRandomInt(-5, 10)],
          },
        ]
    },

    data_invoice_trending : {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
          {
            label: 'Invoice',
            backgroundColor: 'rgba(0,145,218,0.5)',
            borderColor: 'rgba(0,94,184,1)',
            //pointColor: 'rgba(220,220,220,1)',
            //pointStrokeColor: '#fff',
            //pointHighlightFill: '#fff',
            //pointHighlightStroke: 'rgba(220,220,220,1)',
            data: [17000000.00 + getRandomInt(-5,100), 
            11000000.00 + getRandomInt(-5,100), 
            17000000.00 + getRandomInt(-5,100), 
            12000000.00 + getRandomInt(-5,100), 
            37000000.00 + getRandomInt(-5,100), 
            20000000.00 + getRandomInt(-5,100), 
            10000000.00 + getRandomInt(-5,100), 
            13000000.00 + getRandomInt(-5,100), 
            11000000.00 + getRandomInt(-5,100), 
            6600000.00 + getRandomInt(-5,100), 
            16000000.00 + getRandomInt(-5,100), 
            14000000.00 + getRandomInt(-5,100)],
          },
        ]
    }
});

class ProcurementOverview extends Component {
    constructor(props) {
		super(props);
        this.state = {
            value:0
        }
    }

    handleChange = (event, value) => {
         this.setState({ value });
    };




    getTasks(){
        axios.get(config.task)
        .then(res => {
            let tasks = res.data;
            let task_data = []
            task_data.push(tasks.filter(task=>task.status=='Draft').length)
            task_data.push(tasks.filter(task=>task.status=='Pending Response').length)
            task_data.push(tasks.filter(task=>task.status=='Pending Review').length)
            task_data.push(tasks.filter(task=>task.status=='Rejected').length)
            task_data.push(tasks.filter(task=>task.status=='Completed').length)
            // console.log("in dashboard")
            // console.log(res)
            // console.log(alert_data)
            let data={
                labels: [
                'Draft',
                'Pending Response',
                'Pending Review',
                'Rejected',
                'Completed'
                ],
                datasets:[{
                    data:task_data,
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#990099',
                        '#ff9900'
                        ],
                        hoverBackgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#FF6384',
                        '#36A2EB'
                        ]
                }]
            }
            this.setState({
                taskStatusData: data
            })
        })
    }
    getAlerts(){
        axios.get(config.allAlerts)
        .then(res => {
            let alerts = res.data;
            let alert_data = []
            alert_data.push(alerts.filter(alert=>alert.status=='Open').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Investigating').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Pending Review').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Pending Approval For Closure').length)
            alert_data.push(alerts.filter(alert=>alert.status=='Closed').length)
            // console.log("in dashboard")
            // console.log(res)
            // console.log(alert_data)
            let data={
                labels: [
                'Open',
                'Investigating',
                'Pending Review',
                'Pending Approval For Closure',
                'Closed'
                ],
                datasets:[{
                    data:alert_data,
                    backgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#990099',
                        '#ff9900'
                        ],
                        hoverBackgroundColor: [
                        '#FF6384',
                        '#36A2EB',
                        '#FFCE56',
                        '#FF6384',
                        '#36A2EB'
                        ]
                }]
            }
            this.setState({
                alertStatusData: data
            })
        })
    }
    getInitialState() {
    }

    componentDidMount(){
    }

    componentWillMount() {
        this.setState(getState());
        setInterval(() => {
          this.setState(getState());
        }, 4000);
    }
    render() {
        const { classes } = this.props;


        const data_awarded_supplier = {
            labels: ['Supplier 356', 'Supplier 460', 'Supplier 8', 'Supplier 12', 'Supplier 1028'],
            datasets: [
              {
                label: 'No. of Alerts',
                backgroundColor: 'rgba(0,94,184,1)',
                borderColor: 'rgba(0,94,184,1)',
                borderWidth: 0,
                hoverBackgroundColor: 'rgba(0,145,218,0.5)',
                hoverBorderColor: 'rgba(0,145,218,0.5)',
                data: [6985928.95, 3702210.74, 2508000.00, 1716572.34, 1543317.13]
              }
            ]
        };

        const data_approving_officer = {
            labels: ['Carol Hardacred', 'Molly Johnston', 'Melanie Avery', 'Carol Hardacre', 'Max Walsh'],
            datasets: [
              {
                label: 'No. of Alerts',
                backgroundColor: 'rgba(0,94,184,1)',
                borderColor: 'rgba(0,94,184,1)',
                borderWidth: 0,
                hoverBackgroundColor: 'rgba(0,145,218,0.5)',
                hoverBorderColor: 'rgba(0,145,218,0.5)',
                data: [11362733.88, 4856008.68, 4008021.55, 1491486.05, 1093154.80]
              }
            ]
        };

        const data_Invoice_Vendors = {
            labels: ['Vendor 1282', 'Vendor 460', 'Vendor 8', 'Vendor 12', 'Vendor 1028'],
            datasets: [
              {
                label: 'No. of Alerts',
                backgroundColor: 'rgba(0,94,184,1)',
                borderColor: 'rgba(0,94,184,1)',
                borderWidth: 0,
                hoverBackgroundColor: 'rgba(0,145,218,0.5)',
                hoverBorderColor: 'rgba(0,145,218,0.5)',
                data: [24443338.00, 16805911.28, 15564346.14, 14223011.86, 7003852.55]
              }
            ]
        };

        const data_Invoice_approving_officer = {
            labels: ['Richard Hudson', 'Gabrielle Suthe', 'Sam Ubderwood', 'Austin Rutherf', 'Annie MacDonald'],
            datasets: [
              {
                label: 'No. of Alerts',
                backgroundColor: 'rgba(0,94,184,1)',
                borderColor: 'rgba(0,94,184,1)',
                borderWidth: 0,
                hoverBackgroundColor: 'rgba(0,145,218,0.5)',
                hoverBorderColor: 'rgba(0,145,218,0.5)',
                data: [39705613.57, 31721352.27, 22425147.81, 16954558.30, 8323051.00]
              }
            ]
        }

        return (
            <div flexGrow={1}>
                <Grid container spacing={grid_spacing}>
                    <Grid item xs={3}>
                        <CustomizedCard
                            header={'Awarded Tenders:'}
                            contentText={['121']}
                            cardStyle={'veryShort'}
                            action={true}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <CustomizedCard
                            contentText={['$23,760,324.50']}
                            cardStyle={'veryShort'}
                            action={true}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <CustomizedCard
                            header={'Invoices:'}
                            contentText={['7477']}
                            cardStyle={'veryShort'}
                            action={true}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <CustomizedCard
                            contentText={['$155,012,721.33']}
                            cardStyle={'veryShort'}
                            action={true}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <CustomizedCard
                            header = {'Purchase Order Trending'}
                            content = {
                                <CustomizedLineChart
                                    data={this.state.data_tender_trending}
                                />
                            }
                            cardStyle={'1_3rd'}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <CustomizedCard
                            header = {'Purchase Order Trending'}
                            content = {
                                <CustomizedLineChart
                                    data={this.state.data_invoice_trending}
                                />
                            }
                            cardStyle={'1_3rd'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <CustomizedCard
                            header = {'Top 5 supplier by Award Value'}
                            content = {
                                <CustomizedHorizontalBar
                                    data={data_awarded_supplier}
                                />
                            }
                            cardStyle={'1_3rd'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <CustomizedCard
                            header = {'Top 5 Approving Officer by Award Value'}
                            content = {
                                <CustomizedHorizontalBar
                                    data={data_approving_officer}
                                />
                            }
                            cardStyle={'1_3rd'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <CustomizedCard
                            header = {'Top 5 Invoice Vendors by Value'}
                            content = {
                                <CustomizedHorizontalBar
                                    data={data_Invoice_Vendors}
                                />
                            }
                            cardStyle={'1_3rd'}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <CustomizedCard
                            header = {'Top 5 Invoice Approving Officers by Value'}
                            content = {
                                <CustomizedHorizontalBar
                                    data={data_Invoice_approving_officer}
                                />
                            }
                            cardStyle={'1_3rd'}
                        />
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default withStyles(styles)(ProcurementOverview);


// WEBPACK FOOTER //
// ./src/components/Dashboard/ProcurementOverview.js